import { ReactNode } from 'react';
import { Typography } from 'antd';

export type TitleProps = {
  title: ReactNode;
};

export const Title = ({ title }: TitleProps) => (
  <Typography.Title level={3} style={{ margin: '0 0 25px' }}>
    {title}
  </Typography.Title>
);
